(() => {
  const configNode = document.getElementById('fiive-extra-enrollment-config');
  if (!configNode || configNode.dataset.started) return;
  configNode.dataset.started = 'true';
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const hub = `${root}?view=fiive-extra`;
  let busy = false;
  function isEnrollment(link) {
    return link.matches('[data-fiive-extra-enroll]') ||
      (link.getAttribute('href')?.split('?')[0] === config.productUrl && /join|become a member|subscribe/i.test(link.textContent));
  }
  function updateLinks() {
    if (!config.memberActive) return;
    document.querySelectorAll('a[href]').forEach(link => {
      if (isEnrollment(link)) { link.href = hub; link.textContent = config.hubLabel; link.removeAttribute('data-fiive-extra-enroll'); }
    });
  }
  async function json(path, options = {}) {
    const response = await fetch(path, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }
  function post(path, body) {
    return json(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[href]');
    if (!link || !isEnrollment(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    if (config.memberActive) { location.assign(hub); return; }
    busy = true;
    const original = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = config.loading;
    try {
      if (!config.available || !/^\d+$/.test(config.variantId) || !/^\d+$/.test(config.planId)) throw new Error(config.error);
      const state = await json('/apps/fiive-extra-gifts');
      if (['eligible', 'locked'].includes(state.status)) { location.assign(hub); return; }
      if (!['guest', 'nonmember'].includes(state.status)) throw new Error(config.pending);
      const product = await json(`${config.productUrl}.js`);
      const variant = product.variants.find(v => String(v.id) === config.variantId);
      const allocation = variant?.selling_plan_allocations?.find(a => String(a.selling_plan_id) === config.planId);
      if (!variant?.available || allocation?.price !== 6900) throw new Error(config.error);
      let cart = await json(`${root}cart.js`);
      if (cart.currency !== 'USD') throw new Error(config.error);
      const memberships = cart.items.filter(item => String(item.variant_id) === config.variantId || item.sku === 'FP-EXTRA-MONTHLY');
      if (memberships.length > 1 || memberships.some(item => item.quantity !== 1)) throw new Error(config.duplicate);
      if (!memberships.length) {
        await post(`${root}cart/add.js`, { items: [{ id: config.variantId, quantity: 1, selling_plan: config.planId }] });
      } else if (String(memberships[0].selling_plan_allocation?.selling_plan?.id) !== config.planId) {
        await post(`${root}cart/change.js`, { id: memberships[0].key, quantity: 1, selling_plan: config.planId });
      }
      cart = await json(`${root}cart.js`);
      const verified = cart.items.filter(item => String(item.variant_id) === config.variantId || item.sku === 'FP-EXTRA-MONTHLY');
      if (verified.length !== 1 || verified[0].quantity !== 1 || verified[0].final_line_price !== 6900 ||
          String(verified[0].selling_plan_allocation?.selling_plan?.id) !== config.planId) throw new Error(config.error);
      location.assign(`${root}checkout`);
    } catch (error) {
      const status = document.querySelector('[data-fpx-status]');
      if (status) { status.textContent = error.message || config.error; status.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      else window.alert(error.message || config.error);
    } finally { busy = false; link.textContent = original; link.removeAttribute('aria-busy'); }
  });
  updateLinks();
  window.addEventListener('pageshow', updateLinks);
  document.addEventListener('shopify:section:load', updateLinks);
})();
